// Codice affiliato/partner da ?ref= o ?aff= (30 giorni, ultimo click), allegato all'ordine.
const KEY = "vx_aff";
const DAYS = 30;

export const captureAffiliate = () => {
  try {
    const q = new URLSearchParams(window.location.search);
    const code = (q.get("ref") || q.get("aff") || "").replace(/[^A-Za-z0-9_-]/g, "").slice(0, 40);
    if (code) localStorage.setItem(KEY, JSON.stringify({ code: code.toUpperCase(), exp: Date.now() + DAYS * 864e5 }));
  } catch { /* storage unavailable */ }
};

export const getAffiliate = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "null");
    return v && v.exp > Date.now() ? v.code : null;
  } catch {
    return null;
  }
};
